import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=20c1567a&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=20c1567a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c1567a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20c1567a')) {
      api.createRecord('20c1567a', component.options)
    } else {
      api.reload('20c1567a', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=20c1567a&scoped=true&", function () {
      api.rerender('20c1567a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-82QTzVic7gzFj/JS/comp/PopupDialog.vue"
export default component.exports